import * as React from 'react';
import Grid from '@mui/material/Grid';
import RadioGroup from '@mui/material/RadioGroup';
import { useField } from 'formik';
import Radio from '../Radio';

export default function RadioGroupComponent({ list = [], name, compact }) {
  const [field] = useField({ name });
  return (
    <RadioGroup
      row
      aria-label="Additional Pets"
      space={2}
      {...field}
    >
      <Grid
        container
        spacing={1}
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {list.map((x, index) => (
          <Grid item xs={12} sm={compact ? 2 : 3} key={index}>
            <Radio {...x} />
          </Grid>
        ))}
      </Grid>
    </RadioGroup>
  );
}
